
export const setEmailBodySemanaDePosgrado = (props, urlArchivo) => {

    // console.log(props);
    const styles = {
        p:{border:'1px solid gray', width:'380px', backgroundColor:'#ddd'},
        div:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#ddd'},
        divWhite:{textAlign:'center', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
        divWhiteLeft:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#fff'},
        divWhiteLeftNoBorder:{width:'380px', padding:'10px 20px', margin:'10px 0',backgroundColor:'#fff'},
        li:{padding:'6px 0'},
    }



    return (
        <>
            <div style={styles.divWhite}>
            <h2>Semana de posgrado</h2>
            </div>
            <div style={styles.divWhite}>
                <p>¡Su registro ha sido completado con éxito!</p>
            </div>
            <div style={styles.div}>
                <h4>Datos generales</h4>
                <p>
                    Nombre completo: {props.estNombres} {props.estApellidoPaterno} {props.estApellidoMaterno}<br />
                    Sexo: {props.estSexo}<br />
                    Fecha de nacimiento: {props.estFechaNac}<br />
                    País: {props.estPais}<br />
                    Estado: {props.estEstado}<br />
                    Nacionalidad: {props.estNacionalidad}<br />
                    Correo: {props.estCorreo}<br />
                </p>
            </div>
            <div style={styles.div}>
                <h4>Participación</h4>
                <p>
                    Procedencia: {props.partInstProcedencia}<br />
                    Programa: {props.partPrograma}<br />
                    Año: {props.partYear}<br />
                    Modalidad: {props.partModalidad}<br />
                    Participa en arte científico: {props.partArteCient}<br />
                    PRONACES: {props.partPronaces}<br />
                </p>
            </div>
            <div style={styles.div}>
                <h4>Resumen</h4>
                <p>
                    Título: {props.resTitulo}<br />
                    Director: {props.resDirector}<br />
                    <a href={urlArchivo}>Enlace al archivo</a>
                </p>
            </div>
            <div style={styles.divWhiteLeftNoBorder}>
               <strong><i>Atentamente,<br/>Comité organizador</i></strong>
            </div>
        </>
        
    );
};
